/* ==========================================================================
   Envision - Custom JS
   ========================================================================== */

// BIS anchor toggler: shows BIS only for tracked-and-sold-out variants
(function () {
  function getSelectedVariant(productInfoEl) {
    // Multi-variant products: variant-selects has the data
    var el = productInfoEl.querySelector('variant-selects [data-selected-variant]');
    if (el && el.innerHTML) return JSON.parse(el.innerHTML);
    // Single-variant products: fallback to form's data attribute
    var form = productInfoEl.querySelector('form.main-atc-form[data-selected-variant]');
    return form ? JSON.parse(form.dataset.selectedVariant) : null;
  }

  function setBisEnabled(productInfoEl, variant) {
    var form = productInfoEl.querySelector('form.main-atc-form');
    if (!form) return;
    var shouldShow = Boolean(variant && variant.inventory_management && variant.available === false);
    form.classList.toggle('bis-enabled', shouldShow);
  }

  function initFor(productInfoEl) {
    setBisEnabled(productInfoEl, getSelectedVariant(productInfoEl));
  }

  function onVariantChange(event) {
    var sectionId = event.data.sectionId;
    var productInfoEl = document.querySelector("product-info[data-section='" + sectionId + "'], product-info[data-original-section='" + sectionId + "']");
    if (!productInfoEl) return;
    setBisEnabled(productInfoEl, event.data.variant);
  }

  function start() {
    document.querySelectorAll('product-info').forEach(initFor);
    subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

// Remove inline styles from product description
(function () {
  if (window.location.href.indexOf("/products/") > -1) {
    var productDescription = document.querySelector(".product__description");
    if (productDescription) {
      productDescription.querySelectorAll("*").forEach(function (el) {
        el.removeAttribute("style");
      });
    }
  }
})();